import axios from "./axios";
const api = {};

api.register = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/register`;
  return axios.post(url, body);
};

api.login = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/login`;
  return axios.post(url, body);
};
api.logout = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/logout`;
  return axios.post(url, body);
};
api.forgetPass = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/forget-password`;
  return axios.post(url, body);
};
api.resetPass = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/reset-password`;
  return axios.post(url, body);
};
api.adminLogin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/login`;
  return axios.post(url, body);
};
api.adminLogout = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/logout`;
  return axios.get(url);
};
api.allUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/users`;
  return axios.post(url, body);
};
api.allWalletUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/wallet-users`;
  return axios.post(url, body);
};
api.getPaidUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/paid-users`;
  return axios.post(url, body);
};
api.searchPaidUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/search-paid-users`;
  return axios.post(url, body);
};
api.searchUnsubscribedUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/search-unsubscribe-user`;
  return axios.post(url, body);
};
api.getUnSubscribedUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/unsubscribe-users`;
  return axios.post(url, body);
};
api.deleteUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/delete/user`;
  return axios.post(url, body);
};
api.allSurvey = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/survey`;
  return axios.post(url, body);
};
api.sendMailToAllUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-to-all-user`;
  return axios.post(url, body);
};
api.sendMailToAllUserEid = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-to-all-user-eid`;
  return axios.post(url, body);
};
api.sendMailToPaidUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-to-paid-user`;
  return axios.post(url, body);
};
api.sendMailToNonPaidUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-to-non-paid-user`;
  return axios.post(url, body);
};
api.sendMailToAllLockers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/locked/sent-mail-all-lockers`;
  return axios.post(url, body);
};
api.sendPostMailToAllUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-post-mail-to-all-user`;
  return axios.post(url, body);
};
api.sendMonthlySummaryMail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/admin/send-mail-monthly-summary`;
  return axios.post(url, body);
};
api.verifySession = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/check/session`;
  return axios.post(url, body);
};
api.verifySuperAdminSession = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/is-session-valid`;
  return axios.post(url, body);
};
api.survey = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/survey`;
  return axios.post(url, body);
};
api.userEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/edit`;
  return axios.post(url, body);
};
api.userProfileEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/profileEdit/edit`;
  return axios.post(url, body);
};
api.verifyEmail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/verifyOTP`;
  return axios.post(url, body);
};
api.uploadSingleImg = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload-single-img`;
  return axios.post(url, body);
};
api.uploadFile = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload`;
  return axios.post(url, body);
};
api.uploadPDF = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload-pdf`;
  return axios.post(url, body);
};
api.postCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/post/new`;
  return axios.post(url, body);
};
api.postEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/post/edit`;
  return axios.patch(url, body);
};
api.postDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/post/delete`;
  return axios.delete(url, body);
};
api.postGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/post/get`;
  return axios.post(url, body);
};
api.postGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/post/get`;
  return axios.post(url, body);
};
api.postExportExcel = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/post/export-excel`;
  return axios.postBlob(url, body);
};
api.stocksCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/stocks/new`;
  return axios.post(url, body);
};
api.stocksEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/stocks/edit`;
  return axios.patch(url, body);
};
api.stocksDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/stocks/delete`;
  return axios.delete(url, body);
};
api.stocksGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/stocks/get`;
  return axios.post(url, body);
};
api.stocksGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/stocks/get`;
  return axios.post(url, body);
};
api.martketUpdateCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/market/new`;
  return axios.post(url, body);
};
api.martketUpdateEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/market/edit`;
  return axios.patch(url, body);
};
api.martketUpdateDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/market/delete`;
  return axios.delete(url, body);
};
api.martketUpdateGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/market/get`;
  return axios.post(url, body);
};
api.martketUpdateGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/market/get`;
  return axios.post(url, body);
};
api.videoAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/video/add`;
  return axios.post(url, body);
};
api.videoGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/video/get`;
  return axios.post(url, body);
};
api.videoGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/admin/video/get`;
  return axios.post(url, body);
};
api.videoDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/video/delete`;
  return axios.delete(url, body);
};
api.videoedit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/video/edit`;
  return axios.post(url, body);
};
api.updateVideoOrder = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/video/update-order`;
  return axios.post(url, body);
};
api.broadcastCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/broadcast/new`;
  return axios.post(url, body);
};
api.broadcastEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/broadcast/edit`;
  return axios.patch(url, body);
};
api.broadcastDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/broadcast/delete`;
  return axios.delete(url, body);
};
api.broadcastGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/broadcast/get`;
  return axios.post(url, body);
};
api.broadcastGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/broadcast/get`;
  return axios.post(url, body);
};
api.getDataInfo = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/datainfo`;
  return axios.get(url);
};
api.getWaqarStats = function (fromDate, toDate) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/waqar/stats?from=${fromDate}&to=${toDate}`;
  return axios.get(url);
};
api.getWaqarActiveSubs = function (fromDate, toDate) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/waqar/stats-active-subs`;
  return axios.get(url);
};
api.getUserByMail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get/userbymail`;
  return axios.post(url, body);
};
api.getLockerByMail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/locked/get/email`;
  return axios.post(url, body);
};
api.getLocker = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/locked/get`;
  return axios.post(url, body);
};
api.addWallet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/wallet/add`;
  return axios.post(url, body);
};

api.deleteWallet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/wallet/delete`;
  return axios.post(url, body);
};
api.createPayment = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/create`;
  return axios.post(url, body);
};
api.cancelPayment = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/cancel`;
  return axios.post(url, body);
};
api.editPayment = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/edit`;
  return axios.post(url, body);
};
api.getUserPayHistory = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/history`;
  return axios.post(url, body);
};
api.supportAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/contact-support/add`;
  return axios.post(url, body);
};
api.supportGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/contact-support/get`;
  return axios.post(url, body);
};
api.supportDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/contact-support/delete`;
  return axios.post(url, body);
};

api.cryptoReactionAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/reaction/new`;
  return axios.post(url, body);
};
api.cryptoReactionDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/reaction/delete`;
  return axios.delete(url, body);
};
api.stockReactionAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/stock-reaction/new`;
  return axios.post(url, body);
};
api.stockReactionDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/stock-reaction/delete`;
  return axios.delete(url, body);
};
api.marketReactionAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/market-reaction/new`;
  return axios.post(url, body);
};
api.marketReactionDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/market-reaction/delete`;
  return axios.delete(url, body);
};
api.educationReactionAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/education-reaction/new`;
  return axios.post(url, body);
};
api.educationReactionDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/education-reaction/delete`;
  return axios.delete(url, body);
};
api.checkSubscription = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/check?id=${id}`;
  return axios.get(url);
};
api.getWallet = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/wallet/get?id=${id}`;
  return axios.get(url);
};

api.checkPortfolioExist = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/exist?id=${id}`;
  return axios.get(url);
};
api.getWalletPortfolio = function (wallet) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/wallet/portfolio?wallet=${wallet}`;
  return axios.get(url);
};
api.addPortfolio = async (body) => {
  try {
    const data = await axios
      .post(`${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/add`, body)
      .then((res) => {
        // console.log(res);
        return res;
      });
    return data;
  } catch (err) {
    console.log(err.response.data);
    return err.response.data;
  }
};
api.getPortfolio = async (id) => {
  try {
    // console.log(id);

    const data = await axios
      .get(`${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/get-new`, {
        portfolioID: id,
      })
      .then((res) => {
        // console.log(res);
        return res;
      });
    return data;
  } catch (err) {
    console.log(err.response.data);
    return err.response.data;
  }
};
api.getLatestQuotes = async () => {
  try {
    const data = await axios
      .get(`${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/quotes/latest`)
      .then((res) => {
        // console.log(res);
        return res;
      });
    return data;
  } catch (err) {
    console.log(err.response.data);
    return err.response.data;
  }
};
api.DeleteThisCoin = async (coin, user) => {
  try {
    const data = await axios
      .post(
        `${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/delete-coin-tx-by-user`,
        {
          userID: user,
          coin,
        },
      )
      .then((res) => {
        // console.log(res);
        return res;
      });
    return data;
  } catch (err) {
    console.log(err.response.data);
    return err.response.data;
  }
};

api.deletePortfolio = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/delete`;
  return axios.post(url, body);
};
api.portfolioTxHistory = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/tx/history`;
  return axios.post(url, body);
};
api.superAdminLogin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/login`;
  return axios.post(url, body);
};
api.portfolioInitiate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/initiate`;
  return axios.post(url, body);
};
api.userPortfolioGet = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/portfolio/user-get`;
  return axios.get(url);
};
api.superAdminUserEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/edit-user`;
  return axios.post(url, body);
};
api.SuperAdminCancelSubs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/cancel-subscription`;
  return axios.post(url, body);
};
api.SuperAdminDeleteSubs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/delete-subscription`;
  return axios.post(url, body);
};
api.SuperAdminMakePaidUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/make-user-paid`;
  return axios.post(url, body);
};
api.getUserPaidByAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/user-paid-by-admin`;
  return axios.post(url, body);
};
api.addYearlyContactForm = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/yearly-contact-form`;
  return axios.post(url, body);
};
api.getYearlyContactData = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get/yearly-form`;
  return axios.post(url, body);
};
api.getPaymentHistoryAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/history/admin`;
  return axios.post(url, body);
};
api.getUserLogsAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get/user-logs`;
  return axios.post(url, body);
};
api.getUserByBirthday = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-birthday-user`;
  return axios.post(url, body);
};
api.sendMailTobirthdayUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-to-birthday-user`;
  return axios.post(url, body);
};
api.sendPaidMail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-paid-mail`;
  return axios.post(url, body);
};
api.sendOTPMail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-otp-mail`;
  return axios.post(url, body);
};
api.createTicket = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/create`;
  return axios.post(url, body);
};
api.getTicketByUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/get/byuser`;
  return axios.post(url, body);
};
api.adminEditTicket = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/edit`;
  return axios.post(url, body);
};
api.adminBulkEditTicket = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/bulk-edit`;
  return axios.post(url, body);
};
api.getTicket = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/get?issueId=${id}`;
  return axios.get(url);
};
api.addTicketChat = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/add/message`;
  return axios.post(url, body);
};
api.editTicketChat = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/edit/message`;
  return axios.post(url, body);
};
api.adminAllTicketGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/all-ticket/get`;
  return axios.post(url, body);
};
api.adminSearchTicket = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/search-ticket-by-email`;
  return axios.post(url, body);
};
api.adminGetTicket = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/get?issueId=${id}`;
  return axios.get(url);
};
api.adminTicketChat = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/add/message`;
  return axios.post(url, body);
};
api.adminEditTicketChat = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/edit/message`;
  return axios.post(url, body);
};
api.getTicketNotification = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/notification`;
  return axios.get(url);
};
api.getTicketNotificationAdmin = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/notification`;
  return axios.get(url);
};
api.getDataInfoSupport = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/datainfo-support`;
  return axios.get(url);
};
api.getSupportAdmin = function (withStats) {
  let url = "";
  if (withStats) {
    url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get/support-admin-stats`;
  } else {
    url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get/support-admin`;
  }
  return axios.get(url);
};
api.editSupportStatus = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/edit-support-online-status`;
  return axios.post(url, body);
};
api.sendCustomMail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-custom-mail`;
  return axios.post(url, body);
};
api.addTemplate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/add-template`;
  return axios.post(url, body);
};
api.deleteTemplate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/delete-template`;
  return axios.post(url, body);
};
api.getTemplate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-template`;
  return axios.post(url, body);
};
api.addTemplateCategory = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/add-template-category`;
  return axios.post(url, body);
};
api.getTemplateCategory = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-template-category`;
  return axios.get(url);
};
api.getConsentsUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/consents/users`;
  return axios.post(url, body);
};
api.getConsentsSubs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/consents/subscription`;
  return axios.post(url, body);
};
api.searchConsentsUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/consents/users/search`;
  return axios.post(url, body);
};
api.getUnauthTrans = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-unauthorize-transaction`;
  return axios.post(url, body);
};
api.searchUnAuthTrans = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/search-unauthorize-transaction`;
  return axios.post(url, body);
};
api.searchConsentsSubs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/consents/subs/search`;
  return axios.post(url, body);
};
api.addConsents = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/add-consent`;
  return axios.post(url, body);
};
api.addSubscriptionConsents = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/add-subscription-consent`;
  return axios.post(url, body);
};
api.checkSubscriptionConsents = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/check-subscription-consent`;
  return axios.get(url);
};
api.updateEducationOrder = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/education-order-update`;
  return axios.post(url, body);
};
api.sendCustomPushNotif = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/notifications/custom`;
  return axios.post(url, body);
};
api.sendmailToNonPaidStartLearn = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-non-paid-start-learn`;
  return axios.get(url);
};
api.sendmailToNonPaidEidAdha26 = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/send-mail-to-nonp-user-eid`;
  return axios.get(url);
};
api.memberFeedbackAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/member-feedback/add`;
  return axios.post(url, body);
};
api.memberFeedbackGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/member-feedback/get`;
  return axios.post(url, body);
};
api.memberFeedbackSeacrh = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/member-feedback/search`;
  return axios.post(url, body);
};
api.memberFeedbackSubmitted = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/member-feedback/sumitted`;
  return axios.get(url);
};
api.adminAddPermission = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/add-permission`;
  return axios.post(url, body);
};
api.addGodzillaConsents = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/add-godzilla-consent`;
  return axios.post(url, body);
};
api.getGodzillaConsents = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/check-godzilla-consent`;
  return axios.get(url);
};
api.getSubscriptionStatus = function (email) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/status/${email}`;
  return axios.get(url);
};
api.getDuplicateUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-duplicate-users`;
  return axios.post(url, body);
};
api.getCanSubscribe = function (email) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/can-subscribe/${email}`;
  return axios.get(url);
};
api.getCoinCalculator = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/coinCaculator`;
  return axios.post(url, body);
};
api.getStripeSubsByAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/check-stripe-subs`;
  return axios.post(url, body);
};
api.getStripeCustomerData = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/check-stripe-data`;
  return axios.post(url, body);
};
api.getCanceledSubs24h = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/canceled-subs-24h`;
  return axios.get(url);
};
api.getMarketTrend = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/market-trend`;
  return axios.get(url);
};
api.getLiquidationData = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/get/market-liquidation`;
  return axios.post(url, body);
};
api.get24hVolume = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/24h-volume`;
  return axios.post(url, body);
};
api.getliquidityLens = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/liquidity-lens`;
  return axios.post(url, body);
};
api.getliveTrades = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/live-trades`;
  return axios.post(url, body);
};
api.getWhaleTrades = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/whale-trades`;
  return axios.post(url, body);
};
api.getVolatilityIndex = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/volatility-index`;
  return axios.post(url, body);
};
api.generateSummary = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/generate-summary`;
  return axios.post(url, body);
};
api.summaryCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/summary/add`;
  return axios.post(url, body);
};
api.getAdminSummary = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/summary/get`;
  return axios.post(url, body);
};
api.getUserSummary = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/summary/get`;
  return axios.post(url, body);
};
api.summaryDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/summary/delete`;
  return axios.delete(url, body);
};
api.getTopCrypto = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/top-crypto`;
  return axios.get(url, body);
};
api.get20Index = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/cmc20-index`;
  return axios.get(url, body);
};
api.getAltSeasonIndex = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/altseason-index`;
  return axios.get(url, body);
};
api.getMarketCapHistory = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/market-cap`;
  return axios.get(url, body);
};
api.getCMCFearGreed = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/cmc-fear-greed`;
  return axios.get(url, body);
};
api.getOpenInterest = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/open-interest`;
  return axios.get(url, body);
};
api.getEthGas = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/eth-gas-data`;
  return axios.get(url, body);
};
api.getEtfHistory = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/etf-history`;
  return axios.get(url, body);
};
api.getSupportRecentActivity = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-recent-activity`;
  return axios.post(url, body);
};
api.blockEmail = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/blacklist/block`;
  return axios.post(url, body);
};
api.getBlacklistEmails = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/blacklist/list`;
  return axios.post(url, body);
};
api.searchBlacklistEmails = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/blacklist/search`;
  return axios.post(url, body);
};
api.unlockEmail = function (email) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/blacklist/unblock/${email}`;
  return axios.delete(url);
};
api.getEmailLogs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/admin-email-logs`;
  return axios.post(url, body);
};
api.searchEmailLogs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/email-logs/search`;
  return axios.post(url, body);
};
api.tradeDirectoryCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/trade-directory/create`;
  return axios.post(url, body);
};
api.tradeDirectoryGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/trade-directory/get`;
  return axios.post(url, body);
};
api.tradeDirectorySearch = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/trade-directory/month`;
  return axios.post(url, body);
};
api.tradeDirectoryDelete = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/trade-directory/${id}`;
  return axios.delete(url);
};
api.tradeDirectoryExit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/trade-directory/exit-trade`;
  return axios.post(url, body);
};
api.getPollsAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/poll/list`;
  return axios.post(url, body);
};
api.createPoll = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/poll/create`;
  return axios.post(url, body);
};
api.pollToggle = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/poll/toggle`;
  return axios.post(url, body);
};
api.getPollsUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/poll/active`;
  return axios.get(url, body);
};
api.votePoll = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/poll/vote`;
  return axios.post(url, body);
};
api.pollResult = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/poll/results`;
  return axios.post(url, body);
};

api.liveSessionAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/live-session/add`;
  return axios.post(url, body);
};
api.liveSessionGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/live-session/get`;
  return axios.post(url, body);
};
api.liveSessionGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL_DASHBOARD}/admin/live-session/get`;
  return axios.post(url, body);
};
api.liveSessionDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/live-session/delete`;
  return axios.delete(url, body);
};
api.liveSessionedit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/live-session/edit`;
  return axios.post(url, body);
};

// live session trade routes
api.liveSessionTradeAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-session-trade/add`;
  return axios.post(url, body);
};
api.liveSessionTradeGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-session-trade/get`;
  return axios.post(url, body);
};
api.liveSessionTradeEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-session-trade/edit`;
  return axios.post(url, body);
};
api.liveSessionTradeDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-session-trade/delete`;
  return axios.delete(url, body);
};
api.liveSessionTradeGetUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/live-session-trade/get`;
  return axios.post(url, body);
};

// future trade routes
api.futureTradeAdd = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/future-trade/add`;
  return axios.post(url, body);
};
api.futureTradeGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/future-trade/get`;
  return axios.post(url, body);
};
api.futureTradeEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/future-trade/edit`;
  return axios.post(url, body);
};
api.futureTradeDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/future-trade/delete`;
  return axios.delete(url, body);
};
api.futureTradeGetUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/future-trade/get`;
  return axios.post(url, body);
};

// challenge routes
api.getChalengePlanAdmin = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get-challenge-plans`;
  return axios.get(url);
};
api.createChallengePlan = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/create-challenge-plan`;
  return axios.put(url, body);
};
api.editChallengePlan = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/edit-challenge-plan`;
  return axios.put(url, body);
};
api.deleteChallengePlan = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/delete-challenge-plan`;
  return axios.post(url, body);
};
api.chalengePlanList = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/challenge-list`;
  return axios.get(url);
};
api.startChallenge = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/challenge-start`;
  return axios.post(url, body);
};
api.userChallenges = function (page, limit, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/challenges?page=${page}&limit=${limit}`;
  return axios.post(url, body);
};
api.userChalengeById = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/challenge-by-id?challengeId=${id}`;
  return axios.get(url);
};
api.userActiveTrade = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/get-user-trades`;
  return axios.get(url, body);
};
api.userPreviousTrade = function (page) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/get-user-closed-trades?page=${page}`;
  return axios.get(url);
};
api.AdminChallenges = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/all-challenges`;
  return axios.post(url, body);
};
api.AdminChallengesByUser = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/user-challenges/${id}`;
  return axios.get(url);
};
api.createBtSubscriptionToken = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/create-subscription-token-bt`;
  return axios.post(url, body);
};
api.createBtSubscription = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/create-subscription-bt`;
  return axios.post(url, body);
};
api.cancelBtSubscription = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/cancel-subscription-bt`;
  return axios.post(url, body);
};
api.getCanSubscribeBt = function (email) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment/can-subscribe-bt/${email}`;
  return axios.get(url);
};
api.submitTicketFeedback = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/ticket/submit-feedback`;
  return axios.post(url, body);
};
api.getTicketFeedback = function ({ body }) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/ticket/get/feedback`;
  return axios.post(url, body);
};

// for mobile app
api.bannerCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/add-banner`;
  return axios.post(url, body);
};
api.bannerEdit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/edit-banner`;
  return axios.patch(url, body);
};
api.bannerDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/delete-banner`;
  return axios.delete(url, body);
};
api.bannerGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/banner/get`;
  return axios.post(url, body);
};
api.addPushLogs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/add/push-notify-logs`;
  return axios.post(url, body);
};
api.getPushLogs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/get/push-notify-logs`;
  return axios.post(url, body);
};
api.noticeCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/add-notice`;
  return axios.post(url, body);
};
api.noticeToggle = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/toggle-notice`;
  return axios.patch(url, body);
};
api.noticeDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/delete-notice`;
  return axios.delete(url, { data: body });
};
api.noticeGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/notice/get`;
  return axios.post(url, body);
};
api.getYubitReferredUsers = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/yubit/referred-users`;
  return axios.post(url, body);
};
api.liveTradeCreate = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/create`;
  return axios.post(url, body);
};
api.liveTradeGetAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/get`;
  return axios.post(url, body);
};
// api.liveTradeGet = function (body) {
//   const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/get`;
//   return axios.post(url, body);
// };
api.liveTradeClose = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/live-trade/close`;
  return axios.post(url, body);
};
api.liveTradeStats = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/stats`;
  return axios.get(url);
};
api.liveTradeUpdatePnl = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/update-old-pnl`;
  return axios.post(url, body);
};
api.liveTradeGetByRange = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/get-by-range`;
  return axios.post(url, body);
};
api.liveTradeTVGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/live-trade/tradingveiw/get`;
  return axios.post(url, body);
};
api.updateUserProfileImg = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload-user-profile`;
  return axios.post(url, body);
};
api.directPaySession = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/direct/payment/create`;
  return axios.post(url, body);
};
api.getDirectCanSubscribe = function (email) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/direct/payment/can-subscribe/${email}`;
  return axios.get(url);
};
api.directsubsGet = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/direct/payment/get`;
  return axios.post(url, body);
};
api.sendOtpMailUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/send-otp`;
  return axios.post(url, body);
};
api.sendOnlyOtp = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/send-only-otp`;
  return axios.post(url, body);
};
api.isOtpVerified = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/isOtpVerified`;
  return axios.post(url, body);
};
api.changePassword = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/change-password`;
  return axios.post(url, body);
};
api.isEmailVerified = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/isverified`;
  return axios.post(url, body);
};
api.searchTempSubs = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/search/temp-subscription`;
  return axios.post(url, body);
};
api.userLoginbyAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/user-login-master`;
  return axios.postWithAPIKEY(url, body, process.env.REACT_APP_MASTER_API_KEY);
};
api.getChatHistory = function (sessionId) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/chat/history/${sessionId}`;
  return axios.get(url);
};
api.endLiveChat = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/chat/end`;
  return axios.post(url, body);
};
// api.getLivetradesByUser = function (body) {
//   const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/live-trade/get`;
//   return axios.post(url, body);
// };
api.getGodzillaByUser = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/godzilla-trade/get`;
  return axios.post(url, body);
};
api.getGodzillaByAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/godzilla-trade/get`;
  return axios.post(url, body);
};
api.getGodzillaStats = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/godzilla-trade/stats`;
  return axios.get(url);
};
api.godzillaDelete = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/godzilla-trade/delete`;
  return axios.delete(url, body);
};
api.getFreePostByAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/free-post/get`;
  return axios.post(url, body);
};
api.deleteFreePost = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/free-post/delete`;
  return axios.delete(url, body);
};
api.verifyGodzillaBalance = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/weex-verify-web`;
  return axios.post(url, body);
};
api.verifyGodzillaMexc = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/mexc-verify-web`;
  return axios.post(url, body);
};
api.grantGodzillaAccess = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/grant-godzilla-access`;
  return axios.post(url, body);
};
api.removeGodzillaAccess = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/remove-godzilla-access`;
  return axios.post(url, body);
};
api.grantDemoTrading = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/grant-demo-trading`;
  return axios.post(url, body);
};
api.checkWeexByAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/check-godzilla-weex`;
  return axios.post(url, body);
};
api.checkMexcByAdmin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/super-admin/check-godzilla-mexc`;
  return axios.post(url, body);
};

api.getStoriesAdmin = function (params) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/story/all`;
  return axios.get(url, params);
};
api.deleteStory = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/story/${id}`;
  return axios.delete(url);
};

// Onboarding course
api.getOnboardingStatus = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/onboarding/status`;
  return axios.post(url, {});
};
api.markVideoWatched = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/onboarding/mark-watched`;
  return axios.post(url, body);
};
api.skipOnboarding = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/onboarding/skip`;
  return axios.post(url, {});
};
api.completeOnboarding = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/onboarding/complete`;
  return axios.post(url, {});
};

// demo trading
api.getDemoStatus = function () {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/demo-trading/status`, {});
};
api.submitDemoPrediction = function (body) {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/demo-trading/submit`, body);
};
api.retryDemoSession = function () {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/demo-trading/retry`, {});
};

api.getOnboardingAdminSettings = function () {
  return axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/onboarding/settings`);
};
api.updateOnboardingAdminSettings = function (body) {
  return axios.put(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/onboarding/settings`, body);
};
api.getOnboardingAdminUsers = function (params) {
  return axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/onboarding/users`, params);
};
api.requestCertification = function () {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/user/request-certification`, {});
};
api.getCertificationStatus = function () {
  return axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/user/certification-status`);
};
api.adminAcceptCertification = function (body) {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/onboarding/accept-certification`, body);
};
api.adminGenerateCertificate = function (body) {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/onboarding/generate-certificate`, body);
};

// Trade Monitor
api.assignSupportBalance = function (body) {
  return axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/support/assign-balance`, body);
};
api.getSupportPortfolio = function (adminId) {
  return axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/support/portfolio?adminId=${adminId}`);
};
api.getSupportTrades = function (adminId, status) {
  const params = status ? `adminId=${adminId}&status=${status}` : `adminId=${adminId}`;
  return axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/support/trades?${params}`);
};
api.getSupportLiveTrades = function (adminId) {
  return axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/admin/support/live-trades?adminId=${adminId}`);
};

export default api;
